import React from 'react';
import ParentSwitch from './ParentSwitch';

// Parent's switch for whether this child may enter their own recordings in a Reading Bee. Off by default.
const BeeEntriesToggle = ({ studentId, studentName }) => (
  <ParentSwitch
    studentId={studentId}
    field="allow_bee_entries"
    testId="bee-entries-toggle"
    title={`Let ${studentName} enter Reading Bees`}
    help={`Off by default. When it is on, ${studentName} can enter their own recordings, and other Reading Bee participants can hear them. You can also enter recordings yourself from the Reading Bee tab.`}
    onMessage={`${studentName} can now enter Reading Bees`}
    offMessage={`${studentName} can no longer enter Reading Bees`}
  />
);

export default BeeEntriesToggle;
